import { getConfigData } from '../Utils/Storage';

// getAuthData to retrive jarvis data from localStorage
export const getAuthData = () => {
  try {
    const jarvisData = localStorage.getItem('Jarvis');
    if (jarvisData) {
      const parsedData = JSON.parse(jarvisData);
      return parsedData[0];
    }
    return null;

  } catch (error) {
    console.error('Error parsing auth data:', error);
    window.location.href = '/';
    return null;
  }
};


// Generate next Product ID by finding max PID and adding 1
export const generateProductId = () => {
  try {
    const configData = getConfigData();
    const products = configData.Products ? JSON.parse(configData.Products) : [];

    if (!Array.isArray(products) || products.length === 0) {
      return 1;
    }

    const maxPID = Math.max(...products.map(product => product.PID || 0));

    return maxPID + 1;

  } catch (error) {
    console.error('Error generating product ID:', error);
    return 1;
  }
};